import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { createMonthObject } from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationModal/helpers/dataHelpers';
import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';

type Props = {
    value: string;
    onChange: (event: SelectChangeEvent<string>) => void;
};

export default function SimulationInitMonthSelector(
    props: Props,
): React.ReactElement {
    const { t } = useTranslation();
    const { value, onChange } = props;

    const months = [
        createMonthObject(1),
        createMonthObject(2),
        createMonthObject(3),
    ];

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl required fullWidth>
                <InputLabel
                    sx={{
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                    }}
                >
                    {t('humanResources.simulation.selectMonthRecurrent')}
                    <Tooltip
                        title={t(
                            'humanResources.simulation.selectMonthRecurrentTooltip',
                        )}
                    >
                        <InfoIcon
                            color="primary"
                            sx={{
                                fontSize: 16,
                                // this little hack is to force the tooltip to show
                                // event for a textfield label which disables pointerEvents by default
                                pointerEvents: 'auto !important',
                            }}
                        />
                    </Tooltip>
                </InputLabel>
                <Select
                    value={value}
                    label={t('humanResources.simulation.selectMonthRecurrent')}
                    onChange={onChange}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.simulation.selectMonthRecurrent')}
                    </MenuItem>
                    {months.map((month) => (
                        <MenuItem value={month.value} key={month.label}>
                            {month.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
